export default __webpack_public_path__ + "static/media/ChevronDown.b95f32d2.svg";